import loadScript from '~/utils/loadScript'
import appendUrlParam from '~/utils/appendUrlParam'

export default {
  data() {
    return {
      isLoading: true,
      paypalActive: false,
    }
  },
  methods: {
    initPaypalButton(guestCheckout, paymentMethodId) {
      this.paymentMethodId = paymentMethodId
      loadScript('https://www.paypalobjects.com/api/checkout.js')
        .then(() => this.loadPaypalButton(guestCheckout))
        .catch(() => {
          this.$displayTopMessage(this.$t('action_error'), {
            type: 'error',
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadPaypalButton(guestCheckout) {
      this.paypalActive = true

      window.paypal.Button.render(
        {
          env: 'production',
          style: {
            size: 'responsive',
            tagline: false,
            shape: 'rect',
            height: 50,
          },
          payment: async (resolve, reject) => {
            try {
              const PATH = appendUrlParam(
                `/paypal/create/${this.orderNumber}`,
                {
                  ...this.$store.getters.storeInfo,
                  guest_checkout: guestCheckout,
                  token: this.$config.spreeToken,
                  payment_method_id: this.paymentMethodId,
                }
              )
              const { paypal_id: paypalId } = await this.$axios.$post(PATH, {})
              this.paypalId = paypalId
              resolve(paypalId)
            } catch (err) {
              reject(err)
              this.$sentry.captureException({
                error: 'PayPal checkout fails: create order',
                params: {
                  message: err.response || err,
                  order: this.orderNumber,
                },
              })
              this.$displayTopMessage(
                'An error occurred when try connect to PayPal. Please try again.',
                {
                  type: 'error',
                }
              )
            }
          },
          onAuthorize: async (data) => {
            try {
              const PATH = appendUrlParam(
                `/paypal/finalize/${this.orderNumber}`,
                {
                  ...this.$store.getters.storeInfo,
                  token: this.$config.spreeToken,
                  paypal_id: this.paypalId,
                  payment_method_id: this.paymentMethodId,
                }
              )

              document.querySelector('#paypal-button').style.display = 'none'
              const response = await this.$axios.$post(PATH, {})
              window.location.replace(response.path)
            } catch (err) {
              this.$displayTopMessage(err?.response?.data?.message, {
                type: 'error',
              })
              this.$sentry.captureException({
                error: 'PayPal checkout fails: finalize order',
                params: {
                  message: err.response || err,
                  order: this.orderNumber,
                },
              })
            }
          },
          onCancel: (data, actions) => {
            document.querySelector('#paypal-button').style.display = ''
            this.$displayTopMessage('The payment has been cancelled.', {
              type: 'error',
            })
          },
          onError: (xhr) => {
            let response
            if (xhr.message) {
              response = xhr.message
            } else {
              response =
                'An error occurred when try connect to PayPal. Please try again.'
            }
            document.querySelector('#paypal-button').style.display = ''
            this.$displayTopMessage(response, {
              type: 'error',
            })
            this.$sentry.captureException({
              error: 'PayPal guest checkout fails',
              params: {
                message: response,
                order: this.orderNumber,
              },
            })
          },
        },
        '#paypal-button'
      )
    },
  },
}
